function getIndexOfScratcher(scratchers, slug){
  return scratchers.findIndex(scratcher => scratcher.slug === slug);
}

export function getNextSlug(scratchers, slug){
  const length = scratchers.length;
  const pos = getIndexOfScratcher(scratchers, slug);
  const posNext = pos + 1;
  if(typeof scratchers[posNext] == 'undefined'){
    return scratchers[0].slug;
  } else {
    return scratchers[posNext].slug;
  }
}

export function getPrevSlug(scratchers, slug){
  const length = scratchers.length;
  const pos = getIndexOfScratcher(scratchers, slug);
  const posPrev = pos - 1;
  if(typeof scratchers[posPrev] == 'undefined'){
    return scratchers[scratchers.length - 1].slug;
  } else {
    return scratchers[posPrev].slug;
  }
}

const scratchers = [
  {
    slug: 'holiday-riches',
    name: 'Holiday Riches',
    image: '../../../images/tickets/HolidayRiches.png',
    ogImage: '/images/tickets/HolidayRiches.png',
    width: '383.5',
    height: '575',
    x: '212.292',
    y: '135.697',
    description: [
      `Let Holiday Riches add some sparkle to your holidays! With
      three unique games, a bonus and a $150,000 top prize, Holiday
      Riches is sure to give you or anyone on your gift list plenty
      of <em>Scratcher</em> fun this holiday season! Scroll down for odds.`,

      `And this year, all five of our Holiday <em>Scratchers</em> have eXTRA
      Chances to win! Enter your non-winning Holiday Riches into
      the eXTRA Chances Promotion for a chance to win a $75 Cash
      Card instantly (30 per day) and $500,000 in cold, hard cash.`
    ],
    howToPlay:
      `Game #1: Match any of YOUR NUMBERS to the WINNING NUMBER, win
      PRIZE shown for that number. Reveal a HOLLY, win DOUBLE PRIZE shown! Game #2:
      Reveal 3 identical symbols in the same ROW, win PRIZE shown to the right of
      that ROW. Game #3: Reveal a BELLS, win the PRIZE shown. Reveal a 5X, win 5
      TIMES the PRIZE shown!`,
    odds: `Top Prize: 1 in 795,600 <br /> Any Prize: 1 in 4.31`,
    table: [
      ['$150,000', '4', '4'],
      ['$10,000', '5', '4'],
      ['$2,000', '13', '12'],
      ['$500', '52', '44'],
      ['$100', '5,067','4,571'],
      ['$50', '16,813', '15,144'],
      ['$25', '79,319', '71,287'],
      ['$20', '158,638', '142,598'],
      ['$10', '237,957', '214,324'],
      ['$5', '237,957', '214,742'],
    ]
  },
  {
    slug: 'seasons-winnings',
    name: 'Season\'s Winnings',
    image: '../../../images/tickets/SeasonsWinnings.png',
    ogImage: '/images/tickets/SeasonsWinnings.png',
    width: '575',
    height: '575',
    x: '116.542',
    y: '135.697',
    description: [
      `Ready for the most exciting new game of the season? Season’s Winnings is
      the oversized gift that keeps on giving with four different games to play
      and a bonus for 41 chances to win up to $250,000! A big ticket with so many
      chances to win, Season’s Winnings is the perfect gift for you or anyone on
      your shopping list this year! Scroll down for odds.`,

      `And this year, all four of our Holiday <em>Scratchers</em> have eXTRA Chances to win!
      Enter your non-winning Season’s Winnings into the eXTRA Chances Promotion
      for a chance to win a $100 Cash Card instantly (30 per day) and $500,000
      in cold, hard cash.`
    ],
    howToPlay:
      `Game #1 – Match any of YOUR NUMBERS to any of the WINNING NUMBERS, win PRIZE shown for that number. Reveal a 10X, win 10 TIMES the PRIZE shown!
      Game #2 – Reveal three HOLLY in any one row, column or diagonal, win PRIZE shown. Reveal a 2X, win DOUBLE the PRIZE shown!
      Game #3 – Reveal three SNOWMAN in any one row, column or diagonal, win PRIZE shown. Reveal a 3X, win TRIPLE the PRIZE shown!
      Game #4 -Match either of YOUR NUMBERS to the LUCKY NUMBER, win PRIZE shown. Reveal a SLEIGH, win PRIZE shown instantly!
      Bonus – Reveal any PRIZE amount, win that amount instantly!`,
    odds: `Top Prize: 1 in 734,400 <br /> Any Prize: 1 in 3.32`,
    table: [
      ['$250,000', '4', '4'],
      ['$5,000', '5', '4'],
      ['$500', '856', '780'],
      ['$250', '7,343', '6,630'],
      ['$100', '32,154','29,072'],
      ['$50', '50,195', '45,397'],
      ['$30', '61,210', '55,334'],
      ['$20', '293,760', '265,770'],
      ['$10', '440,640', '399,154'],
    ]
  },
  {
    slug: 'festive-50',
    name: 'Festive $50\'s',
    image: '../../../images/tickets/Festive50s.png',
    ogImage: '/images/tickets/Festive50s.png',
    width: '568.487',
    height: '426.594',
    x: '119.798',
    y: '204.216',
    description: [
      `Festive $50's has been stuffed, sweetened, kissed and packed with more than
      $1.5 million in $50 prizes and nine Top Prizes of $1,000. Make your holiday
      season – or that of anyone on your gift list – a little merrier & brighter
      with Festive $50's! Scroll down for odds.`,

      `And this year, all five of our Holiday <em>Scratchers</em> have eXTRA Chances to
      win! Enter your non-winning Festive $50's into the eXTRA Chances Promotion
      for a chance to win a $25 Cash Card instantly (30 per day) and $500,000 in
      cold, hard cash.`
    ],
    howToPlay: `Reveal 3 identical amounts, win that amount. Reveal 2 identical
    amounts and a CANDY CANE, win DOUBLE that amount!`,
    odds: `Top Prize: 1 in 1,006,400 <br /> Any Prize: 1 in 4.71`,
    table: [
      ['$1,000', '9', '9'],
      ['$100', '835', '759'],
      ['$50', '30,403', '28,143'],
      ['$25', '17,959', '16,625'],
      ['$10', '62,996', '58,586'],
      ['$5', '89,887', '83,611'],
      ['$2', '629,590', '588,428'],
      ['$1', '1,078,666', '1,010,327'],
    ],
  },
  {
    slug: 'sneak-a-peak',
    name: 'Sneak A Peak',
    image: '../../../images/tickets/SneakPeek.png',
    ogImage: '/images/tickets/SneakPeek.png',
    width: '575',
    height: '575',
    x: '116.542',
    y: '135.697',
    description: [
      `Who hasn’t tried to Sneak A Peek at least once? This year, we dare you to
      Sneak A Peek at a Top Prize of $20,000 or even one of more than 19,000 $50
      prizes. So why not wrap up your holiday shopping with Sneak A peek today? Scroll down for odds.`,

      `And this year, all five of our Holiday <em>Scratchers</em> have eXTRA Chances to
      win! Enter your non-winning Sneak A Peek into the eXTRA Chances Promotion
      for a chance to win a $25 Cash Card instantly (30 per day) and $500,000 in
      cold, hard cash.`
    ],
    howToPlay: `Match any of YOUR NUMBERS to either WINNING NUMBER, win PRIZE
      shown for that number. Reveal an EYE, win that PRIZE instantly.
      Reveal a GIFT, win 5 TIMES the PRIZE shown!`,
    odds: `Top Prize: 1 in 783,360 <br/> Any Prize: 1 in 4.60`,
    table: [
      ['$20,000', '5', '5'],
      ['$1,000', '23', '20'],
      ['$500', '81', '72'],
      ['$100', '1,477', '1,326'],
      ['$50', '19,621', '17,564'],
      ['$20', '31,343', '28,032'],
      ['$10', '78,308', '70,106'],
      ['$5', '289,882', '260,108'],
      ['$2', '430,805', '88,697'],
    ],
  },
  {
    slug: 'raffle',
    name: 'New Year\'s Raffle',
    image: '../../../images/tickets/Raffle.png',
    ogImage: '/images/tickets/Raffle.png',
    width: '325',
    height: '575',
    x: '241.542',
    y: '135.697',
    description: [
      `Our annual holiday tradition continues with our $20 <em>Virginia’s New Year's
      Millionaire Raffle</em> - a limited-time only game offering the best chance
      this year to win $1 million from the Virginia Lottery – 1 in 110,000! Scroll down for odds.`,
      `Sales begin on 11/1/16 with only 330,000 tickets available in the entire game.
      Tickets sell fast and once they’re gone, they’re gone! Our $20 <em>Virginia's
      New Year’s Millionaire Raffle</em> ticket numbers start at 330000 and count
      down to 000001. Each ticket number is issued sequentially as tickets are
      sold, so unfortunately you can’t choose your favorite numbers in this game.`,
      `Tickets for the $20 <em>Virginia New Year’s Millionaire Raffle</em> will be available
      until all 330,000 have been sold or until the end of the day on 12/31/16,
      whichever comes first. If all the tickets aren’t sold by then, your odds
      become even better! `
    ],
    howToPlay: ``,
    odds: ``,
    table: [
      ['$1,000,000', '3', '1 in 110,000'],
      ['$25,000', '6', '1 in 55,000'],
      ['$500', '300', '1 in 1,100'],
      ['TOTAL PRIZES', '309', '1 in 1,068'],
    ]
  },
  {
    slug: 'tacky-sweater',
    name: 'Tacky Sweater Surprise',
    image: '../../../images/tickets/TackySweater.png',
    ogImage: '/images/tickets/TackySweater.png',
    width: '460',
    height: '575',
    x: '174.02',
    y: '135.697',
    description: [
      `Don’t sweat the tacky sweater party this year, we’ve got you covered with
      Tacky Sweater Surprise! This <em>Scratcher</em> has all the tacky fun you could want,
      plus a $50,000 top prize, so dress-up your holidays with Tacky Sweater
      Surprise! Scroll down for odds.`,

      `And this year, all five of our Holiday <em>Scratchers</em> have eXTRA Chances to
      win! Enter your non-winning Tacky Sweater Surprise into the eXTRA Chances
      Promotion for a chance to win a $50 Cash Card instantly (30 per day) and
      $500,000 in cold, hard cash.`
    ],
    howToPlay: `Count the total number of identical symbols revealed in the play
        area. If the total number of identical symbols matches the legend,
        win corresponding prize. Win $5 for each SNOWFLAKE revealed.`,
    odds: `Top Prize: 1 in 856,800 <br /> Any Prize: 1 in 4.26`,
    table: [
      ['$50,000', '4', '3'],
      ['$1,000', '80', '75'],
      ['$500', '353', '324'],
      ['$150', '1,142','1,047'],
      ['$100', '2,845', '2,614'],
      ['$50', '9,955', '9,111'],
      ['$30', '15,384', '14,128'],
      ['$20', '81,720', '74,896'],
      ['$10', '74,989', '68,717'],
      ['$5', '272,484', '250,597'],
      ['$3', '340,610', '313,689'],
    ],
  },
  {
    slug: '20-years-of-cash',
    name: '20 Years of Cash!',
    image: '../../../images/tickets/20YearsCash.png',
    ogImage: '/images/tickets/20YearsCash.png',
    width: '383.333',
    height: '575',
    x: '212.375',
    y: '135.716',
    description: [
      `On this one, the name says it all: 20 Years of Cash! There's more than $26 million in total cash prizes in the entire game. With four top prizes of $2,500 a month for 20 years AND four top prizes of $1,000 a month for 20 years, this game is sure to be your new favorite.`,
    ],
    howToPlay: `Match any of YOUR NUMBERS to any of the WINNING NUMBERS, win PRIZE shown for that number. Reveal a ROLL OF MONEY, win that PRIZE instantly. Reveal a DOUBLE MONEYBAGS, win DOUBLE the PRIZE shown. Reveal a SAFE, win 5 TIMES the PRIZE shown for that symbol!`,
    odds: `Top Prize: 1 in 2,080,800<br /> Any Prize: 1 in 4.21`,
    table: [
      ['$2,500 a month', '4', '4'],
      ['$1,000 a month', '4', '4'],
      ['$10,000', '10', '10'],
      ['$2,000', '25','25'],
      ['$1,000', '1,343', '1,330'],
      ['$500', '1,383', '1,350'],
      ['$100', '34,902', '34,013'],
      ['$50', '49,675', '48,415'],
      ['$25', '55,945', '54,486'],
      ['$20', '123,175', '119,910'],
      ['$15', '82,077', '79,956'],
      ['$10', '738,916', '719,857'],
      ['$5', '862,017', '840,422'],
    ],
  },
  {
    slug: '100x-the-money',
    name: '100X The Money',
    image: '../../../images/tickets/100xMoney.png',
    ogImage: '/images/tickets/100xMoney.png',
    width: '191.667',
    height: '575',
    x: '308.208',
    y: '135.716',
    description: [
      `Simply the highest top prize offered by any <em>Scratcher</em> in the 28-year history of the Virginia Lottery. 100X The Money - a premium ticket with premium features:`,

      `• Three $10,000,000 Top Prizes<br />• Three $1,000,000 Prizes<br />• 2X, 10X, 50X and 100X multipliers<br />• More than $175 Million total cash prizes in the entire game`,

      `Lottery players know the legendary X series of Scratchers always delivers – and 100X The Money pushes the theme to new heights.`,

      `Plus, 100X The Money features an exclusive Second Chance Promotion – Vegas VIP! Available only to 100X The Money players, Vegas VIP gives players a chance to win one of 12 custom Las Vegas experiences. Winners design their own trip to create the ultimate Vegas experience – a personalized VIP trip valued at $10,000!`,

      `Ready to step your game up to a new level?  Look for 100X The Money at a retailer near you.`,
    ],
    howToPlay: `Match any of YOUR NUMBERS to any of the WINNING NUMBERS, in PRIZE shown for that number. Reveal a MONEYSTACK, win PRIZE shown for that symbol. Reveal a 2X, win 2 TIMES the PRIZE shown for that symbol. Reveal a 10X, win 10 TIMES the PRIZE shown for that symbol. Reveal a 50X, win 50 TIMES the PRIZE shown for that symbol. Reveal a 100X, win 100 TIMES the PRIZE shown for that symbol. Reveal a MONEYBAG, win $500 instantly!`,
    odds: `Top Prize: 1 in 2,611,200<br /> Any Prize: 1 in 2.78`,
    table: [
      ['$10,000,000', '3', '2'],
      ['$1,000,000', '3', '2'],
      ['$50,000', '6', '5'],
      ['$20,000', '19', '17'],
      ['$4,000', '254', '202'],
      ['$1,000', '7,112', '5,638'],
      ['$500', '27,165', '20,944'],
      ['$300', '7,703', '5,941'],
      ['$200', '30,459', '23,462'],
      ['$100', '388,788', '299,030'],
      ['$60', '388,762', '299,415'],
      ['$50', '389,251', '299,867'],
      ['$40', '389,338', '299,910'],
      ['$30', '1,166,690', '899,220'],
    ],
  },
  {
    slug: 'chia-cash',
    name: 'Ch-Ch-Ch Chia Cash',
    image: '../../../images/tickets/chiaCash.png',
    ogImage: '/images/tickets/chiaCash.png',
    width: '575',
    height: '575',
    x: '116.542',
    y: '135.716',
    description: [
      `Ch-Ch-Ch Chia! as seen on T.V. You have sung the song, and maybe you have even grown your own pet, but you have never played the game! Introducing Ch-Ch-Ch Chia Cash, all the kitschy fun you’re used to, but with a chance to win up to $30,000.`,

      `And don’t forget to enter your non-winning Ch-Ch-Ch Chia Cash <em>Scratcher</em> into the eXTRA Chances Promotion for a chance to win a $25 Cash Card instantly (30 per day) and $100,000 in cold, hard cash.`,
    ],
    howToPlay: `Match any of YOUR NUMBERS to either WINNING NUMBER, win PRIZE shown for that number. Reveal a 2X, win DOUBLE the PRIZE shown.`,
    odds: `Top Prize: 1 in 1,101,600<br /> Any Prize: 1 in 4.58`,
    table: [
      ['$30,000', '4', '4'],
      ['$500', '165', '154'],
      ['$100', '3,907', '3,692'],
      ['$50', '10,997', '10,362'],
      ['$25', '21,977', '20,678'],
      ['$20', '22,043', '20,806'],
      ['$10', '132,060', '124,487'],
      ['$5', '110,083', '104,076'],
      ['$4', '132,060', '124,807'],
      ['$2', '528,240', '500,242'],
    ],
  },
];

export default scratchers;



/** WEBPACK FOOTER **
 ** ./src/scratchers.js
 **/